class ProductShare extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.button?.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.handleClick);
  }

  get url() {
    return document.querySelector('link[rel="canonical"]')?.href || window.location.href;
  }

  handleClick = () => {
    const data = { title: document.title, url: this.url };
    window.app?.dl?.customClick(this.button.getAttribute('aria-label') || 'Share');

    if (navigator.share && (!navigator.canShare || navigator.canShare(data))) {
      navigator.share(data).catch(() => {});
      return;
    }
    if (!navigator.clipboard) return;
    navigator.clipboard.writeText(data.url).then(() => this.flash());
  };

  flash() {
    this.querySelector('.mt-product__share-tooltip')?.remove();
    const label = document.createElement('span');
    label.className = 'mt-product__share-tooltip';
    label.setAttribute('role', 'status');
    label.textContent = this.dataset.copiedLabel || 'Copied!';
    this.appendChild(label);
    setTimeout(() => label.classList.add('active'), 1);
    setTimeout(() => label.classList.remove('active'), 2000);
    setTimeout(() => label.remove(), 2300);
  }
}

if (!customElements.get('product-share')) customElements.define('product-share', ProductShare);
